<div *ngIf="workspaceFile" class="mc-avatar-list mc-avatar-list-horizontal">
  <ng-container *ngIf="currentWorkspaceFileUser">
    <mc-license-user-avatar *ngIf="currentWorkspaceFileUser?.userId | mcLicenseUserForLicenseAsync : licenseId | async as licenseUser" class="mc-avatar-list-item" [licenseUser]="licenseUser" [showName]="false" size="small">
      <ng-template mcAvatarIndicator>
        <mc-workspace-file-user-status-avatar-indicator [workspaceFiles]="workspaceFiles" [workspaceFileUser]="currentWorkspaceFileUser"></mc-workspace-file-user-status-avatar-indicator>
      </ng-template>
    </mc-license-user-avatar>

    <ng-container *ngIf="showStatusUpdateButton">
      <button type="button" mat-icon-button class="mc-button-small mc-workspace-file-user-status-list-menu-button" [matMenuTriggerFor]="currentUserStatusMenu">
        <mat-icon fontSet="project-titan" fontIcon="icon-down-arrow-90"></mat-icon>
      </button>

      <mat-menu #currentUserStatusMenu="matMenu" [overlapTrigger]="false" class="mc-menu mc-workspace-file-user-status-list-menu">
        <button mat-menu-item class="mc-menu-item-avatar" [disabled]="currentWorkspaceFileUser.status === WorkspaceFileUserStatus.InProgress || disabled" (click)="onWorkspaceFileUserStatusClicked(WorkspaceFileUserStatus.InProgress)">
          <mc-license-user-avatar *ngIf="currentWorkspaceFileUser?.userId | mcLicenseUserForLicenseAsync : licenseId | async as licenseUser" [disabled]="true" [disabledTooltip]="true" [licenseUser]="licenseUser" [showName]="false" size="small">
            <ng-template mcAvatarIndicator>
              <mat-icon class="mc-avatar-indicator-bottom-right mc-avatar-indicator-icon" color="info-2" fontSet="project-titan" fontIcon="icon-dot"></mat-icon>
            </ng-template>
          </mc-license-user-avatar>
          In Progress
        </button>
        <button mat-menu-item class="mc-menu-item-avatar" [disabled]="currentWorkspaceFileUser.status === WorkspaceFileUserStatus.Done || disabled" (click)="onWorkspaceFileUserStatusClicked(WorkspaceFileUserStatus.Done)">
          <mc-license-user-avatar *ngIf="currentWorkspaceFileUser?.userId | mcLicenseUserForLicenseAsync : licenseId | async as licenseUser" [disabled]="true" [disabledTooltip]="true" [licenseUser]="licenseUser" [showName]="false" size="small">
            <ng-template mcAvatarIndicator>
              <mat-icon class="mc-avatar-indicator-bottom-right mc-avatar-indicator-icon" color="info" fontSet="project-titan" fontIcon="icon-completed-filled"></mat-icon>
            </ng-template>
          </mc-license-user-avatar>
          Ready to Commit
        </button>
      </mat-menu>
    </ng-container>
  </ng-container>

  <ng-container *ngFor="let workspaceFileUser of workspaceFileUsers | slice : 0 : truncateEndIndex">
    <mc-license-user-avatar *ngIf="workspaceFileUser.userId | mcLicenseUserForLicenseAsync : licenseId | async as licenseUser" class="mc-avatar-list-item" [licenseUser]="licenseUser" [showName]="false" size="small">
      <ng-template mcAvatarIndicator>
        <mc-workspace-file-user-status-avatar-indicator [workspaceFiles]="workspaceFiles" [workspaceFileUser]="workspaceFileUser"></mc-workspace-file-user-status-avatar-indicator>
      </ng-template>
    </mc-license-user-avatar>
  </ng-container>

  <ng-container *ngIf="truncateList">
    <button mat-icon-button class="mc-workspace-file-user-status-list-more-button mc-avatar-small" [ngClass]="truncateButtonClass" [color]="truncateButtonColor" [matMenuTriggerFor]="usersStatusMenu" [matTooltip]="workspaceFile.userStatuses?.length | mcPluralize: 'total-license-user'">
      <mat-icon fontSet="project-titan" fontIcon="icon-meatballs"></mat-icon>
      <mat-icon *ngIf="allUsersAreDoneInMoreMenu" class="mc-avatar-indicator-bottom-right mc-avatar-indicator-icon" color="info" fontSet="project-titan" fontIcon="icon-completed-filled"></mat-icon>
    </button>

    <mat-menu #usersStatusMenu="matMenu" [overlapTrigger]="false" class="mc-menu mc-workspace-file-user-status-list-menu">
      <ng-container *ngFor="let workspaceFileUser of workspaceFileUsers | slice : truncateEndIndex">
        <button *ngIf="workspaceFileUser.userId | mcLicenseUserForLicenseAsync : licenseId | async as licenseUser" mat-menu-item class="mc-menu-item-avatar" (click)="licenseUserAvatar.onAvatarClicked()" [disabled]="licenseUserAvatar.isUnclickable()">
          <mc-license-user-avatar #licenseUserAvatar [disabled]="true" [disabledTooltip]="false" [licenseUser]="licenseUser" size="small">
            <ng-template mcAvatarIndicator>
              <mc-workspace-file-user-status-avatar-indicator [workspaceFiles]="workspaceFiles" [workspaceFileUser]="workspaceFileUser"></mc-workspace-file-user-status-avatar-indicator>
            </ng-template>
          </mc-license-user-avatar>
        </button>
      </ng-container>
    </mat-menu>
  </ng-container>
</div>